import React from 'react';

const FranceMap = ({ className }) => {
  const regions = [
    { id: 'hauts-de-france', name: 'Hauts-de-France', path: 'M280,45 L300,30 L340,25 L370,35 L380,55 L375,80 L360,95 L340,105 L320,115 L310,130 L295,130 L280,120 L265,105 L260,85 L265,60 Z', active: false },
    { id: 'ile-de-france', name: 'Île-de-France', path: 'M295,130 L320,115 L340,120 L345,140 L335,155 L315,155 L300,150 L290,140 Z', active: false },
    { id: 'grand-est', name: 'Grand Est', path: 'M340,105 L360,95 L375,80 L400,70 L430,80 L450,100 L450,130 L440,155 L425,170 L400,175 L375,165 L355,155 L345,140 L340,120 Z', active: false },
    { id: 'normandie', name: 'Normandie', path: 'M175,95 L205,75 L240,70 L270,60 L280,45 L265,60 L260,85 L265,105 L280,120 L295,130 L290,140 L270,145 L245,140 L220,135 L200,125 L185,115 Z', active: false },
    { id: 'bretagne', name: 'Bretagne', path: 'M80,130 L110,115 L140,108 L165,100 L175,95 L185,115 L190,135 L185,150 L165,160 L140,165 L115,160 L95,150 Z', active: false },
    { id: 'pays-de-la-loire', name: 'Pays de la Loire', path: 'M115,160 L140,165 L165,160 L185,150 L190,135 L200,125 L220,135 L245,140 L255,160 L260,185 L250,210 L230,220 L205,215 L180,205 L158,192 L140,180 Z', active: true },
    { id: 'centre-val-de-loire', name: 'Centre-Val-de-Loire', path: 'M245,140 L270,145 L290,140 L300,150 L315,155 L335,155 L345,140 L355,155 L360,175 L350,200 L335,220 L315,230 L295,225 L275,215 L260,200 L260,185 L255,160 Z', active: true },
    { id: 'bourgogne-franche-comte', name: 'Bourgogne-FC', path: 'M355,155 L375,165 L400,175 L425,170 L440,155 L445,180 L435,210 L420,230 L400,240 L380,235 L365,225 L355,210 L350,200 L360,175 Z', active: false },
    { id: 'nouvelle-aquitaine', name: 'Nouvelle-Aquitaine', path: 'M140,180 L158,192 L180,205 L205,215 L230,220 L250,210 L260,200 L275,215 L295,225 L315,230 L335,220 L330,250 L320,280 L305,310 L285,330 L265,340 L240,345 L220,335 L205,315 L195,290 L185,265 L175,240 L160,215 Z', active: true },
    { id: 'auvergne-rhone-alpes', name: 'Auvergne-RA', path: 'M335,220 L350,200 L355,210 L365,225 L380,235 L400,240 L420,230 L435,240 L450,260 L445,290 L430,310 L410,315 L390,310 L370,300 L350,290 L338,275 L330,250 Z', active: false, future: true },
    { id: 'occitanie', name: 'Occitanie', path: 'M220,335 L240,345 L265,340 L285,330 L305,310 L320,280 L330,250 L338,275 L350,290 L370,300 L390,310 L380,330 L360,345 L335,355 L310,360 L285,360 L260,355 L240,345 Z', active: true },
    { id: 'provence-alpes-cote-d-azur', name: 'PACA', path: 'M390,310 L410,315 L430,310 L445,290 L465,300 L480,315 L475,335 L455,345 L430,350 L405,345 L385,340 L380,330 Z', active: false, future: true },
    { id: 'corse', name: 'Corse', path: 'M490,340 L498,335 L502,350 L505,375 L500,395 L492,405 L486,390 L484,370 L486,350 Z', active: false },
  ];

  return (
    <div className={className}>
      <svg viewBox="60 10 460 410" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        {regions.map((region) => (
          <g key={region.id}>
            <path
              d={region.path}
              fill={region.active ? '#16a34a' : region.future ? '#eab308' : '#cbd5e1'}
              stroke="#fff"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            {region.active && (
              <text
                x={getCentroid(region.path).x}
                y={getCentroid(region.path).y}
                textAnchor="middle"
                dominantBaseline="central"
                fontSize="10"
                fontWeight="700"
                fill="#fff"
                style={{ pointerEvents: 'none' }}
              >
                {region.name.length > 16 ? region.name.substring(0, 14) + '...' : region.name}
              </text>
            )}
          </g>
        ))}
        
        {/* Legend */}
        <g transform="translate(100, 390)">
          <rect x="0" y="0" width="14" height="14" rx="3" fill="#16a34a" />
          <text x="20" y="11" fontSize="11" fill="#475569" fontWeight="600">Couvert</text>
          <rect x="100" y="0" width="14" height="14" rx="3" fill="#eab308" />
          <text x="120" y="11" fontSize="11" fill="#475569" fontWeight="600">Bientôt (2027)</text>
        </g>
      </svg>
    </div>
  );
};

function getCentroid(d) {
  const nums = d.match(/-?\d+(\.\d+)?/g);
  if (!nums) return { x: 0, y: 0 };
  let sumX = 0, sumY = 0, count = 0;
  for (let i = 0; i < nums.length; i += 2) {
    sumX += parseFloat(nums[i]);
    sumY += parseFloat(nums[i + 1]);
    count++;
  }
  return { x: sumX / count, y: sumY / count };
}

export default FranceMap;
